import { render, staticRenderFns } from "./GestioneTimbrature.vue?vue&type=template&id=ccfd4094&"
import script from "./GestioneTimbrature.vue?vue&type=script&lang=js&"
export * from "./GestioneTimbrature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports